const WrongTurn = () => {
  return (
    <div className="wrong">
      Oh no! It seems ou took a wrong turn somewhere...
    </div>
  );
};

export default WrongTurn;
